<div id="{{position}}" class="position-relative">
  <div *ngIf="!loading">
    <section [attr.data-aos]="allElementAnimation ? allElementAnimation : null" class="app-header-background"
      [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }"
      [ngClass]="activatePadding?'header-padding-top':''">
      <div class="section-block pt-40 pb-40 color-white global-max-width">
        <div [attr.data-aos]="textAnimation ? textAnimation : null" class="app-header-headline mb-40">
          <h1 class="center" [ngClass]="[titleSize]"
            [ngStyle]="{ 'font-family': titleFontFamily ? titleFontFamilyName : '' ,'color': titleColor?titleColor:textColor,'font-weight': fontWeight }">
            {{title}}</h1>
          <p *ngIf="subTitle" class="sub-title center" [ngStyle]="{ 'color': textColor }">{{subTitle}}</p>
        </div>
        <div [attr.data-aos]="itemsAnimation ? itemsAnimation : null" class="row full-width collapse">
          <ng-container>
            <div class="content-carousel">
              <div class="carousel">
                <div *ngFor="let item of testimonials; let testimonialIndex = index" class="div4 eachdiv">
                  <div class="userdetails">
                    <div class="imgbox">
                      <img [src]="item.picture" [alt]="item.username" (error)="updateUrl($event)">
                    </div>
                    <div class="detbox">
                      <p class="name dark">{{ item.username }}</p>
                      <p class="designation dark">{{item.userJob}}</p>
                    </div>
                  </div>
                  <div class="review dark">
                    <!-- <h4>An overall wonderful and rewarding experience</h4> -->
                    <p>“ {{ item.testimonial }} ”</p>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <div class="center pt-20">
            <button class="nav-button" (click)="navigate('left')" *ngIf="positionSwitch > 3"
              style="margin-right: 10px;">
              <mat-icon class="icon">arrow_back_ios</mat-icon>
              <span style="color: transparent;position: absolute;">back</span>
            </button>
            <button class="nav-button" *ngIf="data.groupe.length>positionSwitch" (click)="navigate('right')">
              <mat-icon class="icon">arrow_forward_ios</mat-icon>
              <span style="color: transparent;position: absolute;">forward</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
  <app-shape-matrial [shape]="shape" [backgroundColor]="backgroundColor?backgroundColor:'var(--light-bg)'"></app-shape-matrial>
</div>